module.exports = __webpack_public_path__ + "static/media/win_guide.6f10a8d8.svg";